import { useQuery } from "@tanstack/react-query"
import { supabase } from "@/integrations/supabase/client"
import { useAuth } from "./use-auth"

export interface AdminAccess {
  is_platform_admin: boolean
  is_course_admin: boolean
  managed_courses: Array<{
    id: string
    name: string
  }>
}

export function useAdminAccess() {
  const { user, loading: authLoading } = useAuth()

  const { data, isLoading, error, refetch } = useQuery<AdminAccess>({
    queryKey: ["admin_access", user?.id],
    queryFn: async () => {
      if (!user?.id) {
        throw new Error("User not authenticated")
      }

      console.log("[useAdminAccess] Calling get_user_admin_access for user:", user.id)
      const { data, error } = await supabase.rpc("get_user_admin_access", {
        _user_id: user.id,
      })

      if (error) {
        console.error("[useAdminAccess] RPC error:", error)
        throw error
      }

      console.log("[useAdminAccess] RPC response:", data)
      return data as AdminAccess
    },
    enabled: !!user?.id && !authLoading,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 1,
  })

  return {
    adminAccess: data,
    isLoading: isLoading || authLoading,
    error,
    refetch,
    isPlatformAdmin: data?.is_platform_admin ?? false,
    isCourseAdmin: data?.is_course_admin ?? false,
    managedCourses: data?.managed_courses ?? [],
  }
}

